import { render, staticRenderFns } from "./TalkrecordList.vue?vue&type=template&id=13639d26&scoped=true"
import script from "./TalkrecordList.vue?vue&type=script&lang=js"
export * from "./TalkrecordList.vue?vue&type=script&lang=js"
import style0 from "./TalkrecordList.vue?vue&type=style&index=0&id=13639d26&prod&lang=css"
import style1 from "./TalkrecordList.vue?vue&type=style&index=1&id=13639d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13639d26",
  null
  
)

export default component.exports